import { useState } from "react";
import { Download, FileText } from "lucide-react";
import { toast, Toaster } from "react-hot-toast";
import CommonContainer from "../Container/CommonContainer";
import "./MetlinkUploaderComponent.css";
import { FaDownload, FaFileUpload } from "react-icons/fa";
import * as MetlinkService from "../../Services/Metlink/MetlinkService";
import useRightClickDisable from "../../Utils/disableCopyAndDevTools";

const BulkDataImport = () => {
  const [selectedOptionTemplate, setSelectedOptionTemplate] = useState("");
  const [selectedOptionUpload, setSelectedOptionUpload] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  // useRightClickDisable()
 
  const templateLinks = {
    "Monthly Target Data":"",
    "MTD Monthly Data":"",
    "Lead Data":""
  };

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile && uploadedFile.type === "text/csv") {
      setFile(uploadedFile);
    } else {
      toast.error("Please upload a valid CSV file.");
      setFile(null);
    }
  };

  const handleUpload = () => {
    if (!selectedOptionUpload) {
      toast.error("Please select a data type before uploading.");
      return;
    }

    if (!file) {
      toast.error("Please select a CSV file before uploading.");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    const apiMap = {
      "Monthly Target Data": MetlinkService.UploadMonthlyExcel,
      "MTD Monthly Data": MetlinkService.UploadMTDExcel,
    };

    const uploadFunction = apiMap[selectedOptionUpload];

    if (!uploadFunction) {
      toast.error("No API found for selected data type.");
      setLoading(false);
      return;
    }

    uploadFunction(formData)
      .then(({ data }) => {
        if (data.IsSuccess) {
          if (data.ResponseMessage?.toLowerCase().includes("partial success")) {
            toast.error(data.ResponseMessage);

            // Decode base64 file and download automatically
            const byteCharacters = atob(data.Data.FileContents);
            const byteNumbers = new Array(byteCharacters.length)
              .fill()
              .map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: data.Data.ContentType });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = data.Data.FileDownloadName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            toast.success(
              `${file.name} uploaded successfully for ${selectedOptionUpload}`
            );
          }

          setFile(null);
          setSelectedOptionUpload("");
        } else {
          toast.error(data.ResponseMessage);
        }
      })
      .catch(() => {
        toast.error("Something went wrong.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <CommonContainer icon={<FaFileUpload size={20}/>} heading="Metlink Upload Report">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="mt-5">
        {/* Dropdown */}
        <div className="mb-3 d-flex flex-column flex-md-row gap-3">
          <div>
            <label className="form-label select-label">
              Select Data Template
            </label>

            <div className="d-flex align-items-center gap-3">
              <div>
                <select
                  className="form-select"
                  style={{ maxWidth: "200px" }}
                  value={selectedOptionTemplate}
                  onChange={(e) => setSelectedOptionTemplate(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Monthly Target Data">
                    Monthly Target Data
                  </option>
                  <option value="MTD Monthly Data">MTD Monthly Data</option>
                  <option value="Lead Data">Lead Data</option>
                </select>
              </div>

              <div>
                {/* Download section */}
                {selectedOptionTemplate && (
                  <a
                    className="d-flex align-items-center gap-2 px-3 py-2 btn custom-sumbitbtn metlink-admin-download-btn"
                    href={templateLinks[selectedOptionTemplate]}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                  >
                    {/* <Download className="w-2 h-2" /> */}
                    <FaDownload />
                    Download Template
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* File Upload */}
        <div className="mb-3">
          <label className="form-label upload-label">Upload CSV</label>

          {/* Dropdown for selecting data type */}
          <div className="mb-2">
            <select
              className="form-select"
              style={{ maxWidth: "250px" }}
              value={selectedOptionUpload}
              onChange={(e) => setSelectedOptionUpload(e.target.value)}
            >
              <option value="">Select Data Type</option>
              <option value="Monthly Target Data">Monthly Target Data</option>
              <option value="MTD Monthly Data">MTD Monthly Data</option>
              <option value="Lead Data">Lead Data</option>
            </select>
          </div>

          {/* File Input + Upload Button */}
          {selectedOptionUpload && (
            <div className="d-flex gap-2 align-items-center">
              <input
                type="file"
                style={{ maxWidth: "250px" }}
                className="form-control upload-input"
                accept=".csv"
                onChange={handleFileChange}
              />
              <button
                className="btn custom-sumbitbtn metlink-admin-upload-btn"
                onClick={handleUpload}
                disabled={!selectedOptionUpload || !file || loading}
              >
                {loading ? "Uploading..." : "Upload File"}
              </button>
            </div>
          )}
        </div>
      </div>
    </CommonContainer>
  );
};

export default BulkDataImport;
